<template>
  <div class="step1">
    <header-main></header-main>
    <nav-mobile></nav-mobile>
    <section id="order-step1" class="order">
      <header class="main">
        <steps :step="1"></steps>
      </header>
      <div class="wrapper">
        <div class="content">
         <section>
           <header>
             <h4>Wybrana długość trwania usługi</h4>
           </header>
           <packets-period></packets-period>
         </section>
         <section>
           <header class="flex">
             <h4>Wybrany typ pakietu</h4>
             <p @click="togglePackets()">{{ packetsTextActive }}</p>
           </header>
           <div class="flex">
             <div class="extended">
              <div class="packet mini small" :class="{ active: packetActiveReal == 1 }" @click="changePacket(1)">
                <div class="content">
                  <div class="icon"></div>
                  <h5>Pakiet Mini</h5>
                  <h4>{{ prices.mini[monthActive] }} PLN</h4>
                  <p>netto | m-c</p>
                </div>
              </div>
              <ul v-if="packets">
                <li>
                  <i class="material-icons">done</i>
                  <p>rejestracja firmy pod adresem: ul. Świeradowska 51-57, 50-559 Wrocław</p>
                </li>
                <li>
                  <i class="material-icons">done</i>
                  <p>odbieranie korespondencji przychodzącej</p>
                </li>
                <li>
                  <i class="material-icons">done</i>
                  <p>prowadzenie elektronicznego dziennika korespondencji</p>
                </li>
                <li>
                  <i class="material-icons">done</i>
                  <p>powiadomienia e-mail o wpłynięciu korespondencji</p>
                </li>
                <li>
                  <i class="material-icons">done</i>
                  <p>dostęp 24/7 do dziennika korespondencji</p>
                </li>
                <li class="gray">
                  <i class="material-icons">close</i>
                  <p>przesyłanie i dostęp do skanów korespondencji</p>
                </li>
                <li class="gray">
                  <i class="material-icons">close</i>
                  <p>sala konferencyjna 2h w miesiącu</p>
                </li>
                <li class="gray">
                  <i class="material-icons">close</i>
                  <p>wysyłka papierowej korespondencji raz w miesiącu</p>
                </li>
              </ul>
            </div>
            <div class="extended">
              <div class="packet standard small" :class="{ active: packetActiveReal == 2 }" @click="changePacket(2)">
                <div class="content">
                  <div class="icon"></div>
                  <h5>Pakiet Standard</h5>
                  <h4>{{ prices.standard[monthActive] }} PLN</h4>
                  <p>netto | m-c</p>
                </div>
              </div>
              <ul v-if="packets">
                <li>
                  <i class="material-icons">done</i>
                  <p>rejestracja firmy pod adresem: ul. Świeradowska 51-57, 50-559 Wrocław</p>
                </li>
                <li>
                  <i class="material-icons">done</i>
                  <p>odbieranie korespondencji przychodzącej</p>
                </li>
                <li>
                  <i class="material-icons">done</i>
                  <p>prowadzenie elektronicznego dziennika korespondencji</p>
                </li>
                <li>
                  <i class="material-icons">done</i>
                  <p>powiadomienia e-mail o wpłynięciu korespondencji</p>
                </li>
                <li>
                  <i class="material-icons">done</i>
                  <p>dostęp 24/7 do dziennika korespondencji</p>
                </li>
                <li class="blue">
                  <i class="material-icons">done</i>
                  <p>przesyłanie i dostęp do skanów korespondencji</p>
                </li>
                <li class="gray">
                  <i class="material-icons">close</i>
                  <p>sala konferencyjna 2h w miesiącu</p>
                </li>
                <li class="gray">
                  <i class="material-icons">close</i>
                  <p>wysyłka papierowej korespondencji raz w miesiącu</p>
                </li>
              </ul>
            </div>
            <div class="extended">
              <div class="packet comfort small" :class="{ active: packetActiveReal == 3 }" @click="changePacket(3)">
                <div class="content">
                  <div class="icon"></div>
                  <h5>Pakiet Komfort</h5>
                  <h4>{{ prices.komfort[monthActive] }} PLN</h4>
                  <p>netto | m-c</p>
                </div>
              </div>
              <ul v-if="packets">
                <li>
                  <i class="material-icons">done</i>
                  <p>rejestracja firmy pod adresem: ul. Świeradowska 51-57, 50-559 Wrocław</p>
                </li>
                <li>
                  <i class="material-icons">done</i>
                  <p>odbieranie korespondencji przychodzącej</p>
                </li>
                <li>
                  <i class="material-icons">done</i>
                  <p>prowadzenie elektronicznego dziennika korespondencji</p>
                </li>
                <li>
                  <i class="material-icons">done</i>
                  <p>powiadomienia e-mail o wpłynięciu korespondencji</p>
                </li>
                <li>
                  <i class="material-icons">done</i>
                  <p>dostęp 24/7 do dziennika korespondencji</p>
                </li>
                <li class="blue">
                  <i class="material-icons">done</i>
                  <p>przesyłanie i dostęp do skanów korespondencji</p>
                </li>
                <li class="blue">
                  <i class="material-icons">done</i>
                  <p>sala konferencyjna 2h w miesiącu</p>
                </li>
                <li class="blue">
                  <i class="material-icons">done</i>
                  <p>wysyłka papierowej korespondencji raz w miesiącu</p>
                </li>
              </ul>
            </div>
          </div>
         </section>
         <section>
           <header>
             <h4>Wybierz datę rozpoczęcia usługi</h4>
           </header>
           <div class="flex2">
            <vc-date-picker
              v-model="chosenDate"
              :value="chosenDate"
              color="orange"
              :min-date="new Date()"
              :max-date="maxDate"
              locale="pl"
              :pane-width='100'
              />
              <div class="dates">
                <div class="date">
                  <h6>Data rozpoczęcia usługi</h6>
                  <p>{{ dateStartString }}</p>
                </div>
                <div class="date">
                  <h6>Data zakończenia usługi</h6>
                  <p>{{ dateEndString }}</p>
                </div>
              </div>
            </div>
         </section>
       </div>
       <order-nav forwardString="Kontynuuj" backPath="/pakiety" forwardPath="/zamowienie/krok/2"></order-nav>
      </div>
    </section>
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import NavMobile from '@/components/NavMobile.vue'
import FooterMain from '@/components/FooterMain.vue'
import OrderNav from '@/components/OrderNav.vue'
import Steps from '@/components/Steps.vue'
import PacketsPeriod from '@/components/PacketsPeriod.vue'
export default {
  name: 'Step1',
  components: {
    HeaderMain,
    NavMobile,
    FooterMain,
    OrderNav,
    Steps,
    PacketsPeriod
  },
  data(){
    return{
      packets: 0,
      packetActiveReal: 2,
      packetsTextActive: 'Pokaż szczegóły dotyczące pakietów',
      packetsText : ['Pokaż szczegóły dotyczące pakietów', 'Ukryj szczegóły dotyczące pakietów'],
      days: 30,
      endDate: 0,
      maxDate: 0,
      chosenDate: 0,
      dateStartString: '',
      dateEndString: '',
    }
  },
  computed:{
    monthActive(){
      return this.$store.state.monthActive;
    },
    packetActive(){
      return this.$store.state.packetActive;
    },
    prices(){
      return this.$store.state.prices;
    },
  },
  created(){
    this.getPacket();
    this.setChosenDate();
    this.setMaxDate();
    this.setPacket();
  },
  watch:{
    
    chosenDate(){
      this.changeDates();
    },
    monthActive(){
      this.changeDates();
    },
    packetActive(){
      this.getPacket();
    }
  },
  methods:{
    togglePackets(){
      if(this.packets){
        this.packets = 0;
        this.packetsTextActive = this.packetsText[0]
      }else{
        this.packets = 1;
        this.packetsTextActive = this.packetsText[1]
      }
    },
    changePacket(id){
      this.$store.commit('changePacket', id);
      if(typeof localStorage.packet == 'undefined'){
        localStorage.setItem('packet', id);
      }else{
        localStorage.packet = id;
      }
      let formData;
      if(localStorage.formData !== undefined) {
        formData = JSON.parse(localStorage.formData);
      } else {
        formData = {};
      }
      if(formData.packet === undefined) {
        formData.packet = {};
      }
      if(id == 1) {
        formData.packet.name = 'mini';
      } else if(id == 2) {
        formData.packet.name = 'standard';
      } else if(id == 3) {
        formData.packet.name = 'komfort';
      }
      localStorage.setItem('formData', JSON.stringify(formData));
    },
    getPacket(){
      if(typeof localStorage.packet == 'undefined'){
        this.packetActiveReal = this.packetActive;
      }else{
        this.packetActiveReal = localStorage.packet;
      }
    },
    setPacket() {
      let formData;
      if(localStorage.formData !== undefined) {
        formData = JSON.parse(localStorage.formData);
      } else {
        formData = {};
      }
      if(formData.packet === undefined) {
        formData.packet = {};
      }
      if(this.packetActiveReal == 1) {
        formData.packet.name = 'mini';
      } else if(this.packetActiveReal == 2) {
        formData.packet.name = 'standard';
      } else if(this.packetActiveReal == 3) {
        formData.packet.name = 'komfort';
      }
      localStorage.setItem('formData', JSON.stringify(formData));
    },
    setChosenDate(){
      if(typeof localStorage.dateStart == 'undefined'){
        this.chosenDate = new Date();
      }else{
        let now = new Date();
        let lsDate = new Date(localStorage.dateStart);
        let substract = lsDate - now;
        if(substract < 0){
          this.chosenDate = new Date();
        }else{
          this.chosenDate = new Date(localStorage.dateStart);
        }
      }
    },
    setMaxDate(){
      let date = new Date();
      this.maxDate = date.setDate(date.getDate() + 60);
    },
    getEndDate(){
      let date = new Date(this.chosenDate);
      let months = 0;
      switch(this.monthActive){
        case 0:
          months = 3;
        break;
        case 1:
          months = 6;
        break;
        case 2:
          months = 12;
        break;
        default:
          months = 3;
      }
      if(date.getDate() == 1){
        this.endDate = date.setMonth(date.getMonth() + months);
      }else{
        this.endDate = date.getTime() + (this.days * months * 86400000);
      }
      this.endDate = new Date(this.endDate)
    },
    changeDates(){
      this.getEndDate();
      let chosenDays = this.chosenDate.getDate();
      if(chosenDays < 10){
        chosenDays = '0' + chosenDays;
      }
      let chosenMonths = this.chosenDate.getMonth() + 1;
      if(chosenMonths < 10){
        chosenMonths = '0' + chosenMonths
      }
      let endDays = this.endDate.getDate();
      if(endDays < 10){
        endDays = '0' + endDays;
      }
      let endMonths = this.endDate.getMonth() + 1;
      if(endMonths < 10){
        endMonths = '0' + endMonths;
      }
      this.dateStartString = this.chosenDate.getFullYear() + '-' + chosenMonths + '-' + chosenDays;
      this.dateEndString = this.endDate.getFullYear() + '-' + endMonths + '-' + endDays;
      let formData;
      if(localStorage.formData !== undefined) {
        formData = JSON.parse(localStorage.formData);
      } else {
        formData = {};
      }
      formData.startDate = this.chosenDate;
      formData.endDate = this.endDate;
      if(typeof localStorage.dateStart == 'undefined'){
        localStorage.setItem('dateStart', this.chosenDate);
      }else{
        localStorage.dateStart = this.chosenDate;
      }
      if(typeof localStorage.dateEnd == 'undefined'){
        localStorage.setItem('dateEnd', this.endDate);
      }else{
        localStorage.dateEnd = this.endDate;
      }
      localStorage.setItem('formData', JSON.stringify(formData));
    }
  },
  mounted() {
    this.$store.commit('changeOrderNavDisable', false);
    localStorage.setItem('formStep', 1);
  },
}
</script>
<style scoped lang="scss">
  section.order div.content section div.flex { display: flex; flex-wrap: wrap; justify-content: center; margin: 15px 0; }
  section.order div.content section div.flex2 { display: flex; flex-wrap: wrap; justify-content: center; margin-top: 15px; }
  section.order div.packets-period { margin: 30px auto; }
  section.order div.packet.small { cursor: pointer; opacity: 0.5; }
  section.order div.packet.small.active { opacity: 1; }
  section.order div.packet.small.active div.content { height: 150px; background: rgba(218, 78, 1, 0.9); }
  section.order div.extended ul { width: 200px; margin: 0 50px; padding: 0; list-style: none; }
  section.order div.extended ul li { display: flex; margin: 10px 0; padding: 5px; background: #f2f2f2; color: $grayDark; border-radius: 3px; }
  section.order div.extended ul li i.material-icons { display: block; width: 18px; height: 18px; margin-top: 3px; line-height: 18px; font-size: 18px; text-align: center; 
    color: $orangeDark; }
  section.order div.extended ul li.blue i.material-icons { color: $blueDark; }
  section.order div.extended ul li.gray { opacity: 0.4; }
  section.order div.extended ul li.gray i.material-icons { color: $grayLight; }
  section.order div.extended ul li p {  margin: 0 0 0 5px; padding: 0; font-size: 12px; line-height: 24px; }
  section.order div.dates { display: flex; flex-direction: column; justify-content: space-between; }
  section.order div.date { margin: 20px; }
  section.order div.date h6 { margin: 0 0 5px 0; padding: 0; color: $grayLight; font-weight: 500; font-size: 14px; text-align: center; }
  section.order div.date p { margin: 0; padding: 5px 20px; background: #f2f2f2; color: $grayDark; font-size: 22px; text-align: center; }

  div.vc-container { margin: 20px; }

  div.packet.small { width: 200px; height: 250px; }
  div.packet.small div.content { height: 150px; }
  div.packet.small div.content div.icon { display: none; }
  div.packet.small div.content h5 { font-size: 18px; }
  div.packet.small div.content h4 { font-size: 28px; }
  div.packet.small div.content p { font-size: 12px; }

  @media (max-width: 1000px) {
    section.order div.packet.small { margin: 20px; }
  }

  @media (max-width: 500px) {
    section.order div.date { margin: 20px auto; }
  }

  @media (max-width: 450px) {
    div.packets-period { width: 100%; }
  }
</style>
